import styled, { css } from 'styled-components';

import ButtonComponent from 'components/Button/Button';
import { mediaDesktop } from 'utils/styles/responsive';

export const FaqComponentWrapper = styled.div`
  grid-column: 2 / -2;

  ${mediaDesktop(
    css`
      grid-column: 2 / 6;
    `
  )}
`;

export const Title = styled.div`
  margin-bottom: 20px;
`;

export const Button = styled(ButtonComponent)`
  margin-top: 40px;

  ${mediaDesktop(css`
    margin-top: 48px;
  `)}
`;
